import angular from 'angular'
import template from './template.html'

angular.module('nominas.nomina')
  .component('nominasNominaBancosResumen', {
    template: template,
    controller: NominasNominaBancosResumenComponent,
    bindings: {
      idEmpresa: '<',
      idNomina: '<',
    },
  })

function NominasNominaBancosResumenComponent(NominasNominaBancosResumen) {
  let $ctrl = this
  $ctrl.$onInit = $onInit

  function $onInit() {
    $ctrl.data = undefined
    $ctrl.total = 0
    $ctrl.totalPagos = 0
    $ctrl.chart = {
      labels: [],
      data: [],
      colours: ['#F44336', '#FF9800', '#FFEB3B', '#8BC34A', '#009688', '#2196F3', '#673AB7', '#9C27B0', '#E91E63', '#3F51B5'],
    }

    return NominasNominaBancosResumen.get($ctrl.idEmpresa, $ctrl.idNomina)
      .then(function (response) {
        $ctrl.data = response

        angular.forEach($ctrl.data, function (item, index) {
          item.data.color = $ctrl.chart.colours[index]
          $ctrl.chart.labels.push(item.label)
          $ctrl.chart.data.push(item.data.Total_Pagar.toFixed(2))
          $ctrl.total += item.data.Total_Pagar
          $ctrl.totalPagos += item.items.length
        })
      })
  }
}



// WEBPACK FOOTER //
// ./src/nominas/nomina/components/bancos/resumen/component.js